import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import { refreshReloadPrompt } from 'hooks';
import PageTemplate from 'components/general/PageTemplate';
import { getBillTo } from 'api/bill-to';
import BillToModal from './BillTo';
import {
  columns,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
} from './bill-to.config';

const BillTo = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const [modalOpen, setModalOpen] = useState(true);
  const [billTos, setBillTos] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [loading, setLoading] = useState(false);
  const [blockRouteChange, setBlockRouteChange] = useState(false);

  const fetchBillTos = async () => {
    const { data } = await getBillTo(pageNumber, pageSize);

    setBillTos(data);
  };

  useEffect(async () => {
    setLoading(true);

    await fetchBillTos();
    setLoading(false);
  }, [pageNumber, pageSize]);

  const handleModalOpen = ({ id }) => {
    history.push(`/bill-to/${id}`);
    setModalOpen(true);
  };

  const handleAdd = () => {
    history.push('/bill-to/add');
    setModalOpen(true);
    fetchBillTos();
  };

  const handleModalClose = (save) => {
    if (save && typeof save === 'boolean') {
      history.block(() => true);
      setModalOpen(false);
    }

    if (!blockRouteChange && !save && typeof save !== 'boolean') {
      setModalOpen(false);
    }
    history.push('/bill-to');
    fetchBillTos();
    window.removeEventListener('beforeunload', refreshReloadPrompt);
  };

  return (
    <>
      <PageTemplate
        data={get(billTos, 'data', [])}
        columns={columns}
        suggestionPrimaryKey={suggestionPrimaryKey}
        suggestionSecondaryKeys={suggestionSecondaryKeys}
        handleModalOpen={handleModalOpen}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        rowCount={get(billTos, 'pagination.total', 0)}
        pageNumber={pageNumber}
        pageSize={pageSize}
        loading={loading}
        handleAdd={handleAdd}
        setModalOpen={setModalOpen}
      />

      <Switch>
        <Route path={`${path}/:id`}>
          <BillToModal
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>
      </Switch>
    </>
  );
};
export default BillTo;
